(function() {
  const savedColumnsOnInit = localStorage.getItem('ec-collection-columns')
  if (!savedColumnsOnInit || savedColumnsOnInit === '2') {
    localStorage.setItem('ec-collection-columns', '3')
  }
  
  let currentColumns = 3;
  let currentMobileColumns = 1
	let filtersExpanded = false
	let previousColumns = null

	function isMobile() {
		return window.innerWidth <= 989
	}

	function setColumns(columns, skipValidation = false, skipLocalStorage = false) {
		if (!skipValidation && filtersExpanded && columns === 3) {
			return
		}

		currentColumns = columns
		const buttons = document.querySelectorAll('.ec-column-btn')
		const productGrid = document.querySelector('#product-grid')

		buttons.forEach((btn) => {
			if (parseInt(btn.dataset.columns) === columns) {
				btn.classList.add('ec-column-btn--active')
			} else {
				btn.classList.remove('ec-column-btn--active')
			}
		})

		if (productGrid) {
			productGrid.classList.add('ec-columns-changing')

			requestAnimationFrame(() => {
				productGrid.classList.remove('grid--2-col-desktop', 'grid--3-col-desktop')
				productGrid.classList.add(`grid--${columns}-col-desktop`)

				setTimeout(() => {
					productGrid.classList.remove('ec-columns-changing')
				}, 500)
			})
		}

		if (!skipLocalStorage) {
			localStorage.setItem('ec-collection-columns', columns)
		}
	}

	function setMobileColumns(columns, skipLocalStorage = false) {
		currentMobileColumns = columns
		const buttons = document.querySelectorAll('.ec-column-btn-mobile')
		const productGrid = document.querySelector('#product-grid')

		buttons.forEach((btn) => {
			if (parseInt(btn.dataset.columnsMobile) === columns) {
				btn.classList.add('ec-column-btn-mobile--active')
			} else {
				btn.classList.remove('ec-column-btn-mobile--active')
			}
		})

		if (productGrid) {
			productGrid.classList.remove('grid--1-col-tablet-down', 'grid--2-col-tablet-down')
			productGrid.classList.add(`grid--${columns}-col-tablet-down`)
		}

		if (!skipLocalStorage) {
			localStorage.setItem('ec-collection-columns-mobile', columns)
		}
	}

	function updateColumnButtonsState() {
		const buttons = document.querySelectorAll('.ec-column-btn')
		buttons.forEach((btn) => {
			const columns = parseInt(btn.dataset.columns)
			if (filtersExpanded && columns === 3) {
				btn.disabled = true
				btn.classList.add('ec-column-btn--disabled')
			} else {
				btn.disabled = false
				btn.classList.remove('ec-column-btn--disabled')
			}
		})
	}

	function toggleFilters() {
		filtersExpanded = !filtersExpanded
		const facetsForm = document.querySelector('#FacetFiltersForm')
		const facetsWrapper = document.querySelector('#FacetsWrapperDesktop')
		const facetsToggle = document.querySelector('.ec-facets-toggle')
		const facetsLayout = document.querySelector('.ec-facets-layout')
		const toggleButton =
			document.querySelector('.ec-filters-toggle-btn') || document.querySelector('.ec-filter-btn')

		if (facetsForm) {
			if (filtersExpanded) {
				facetsForm.classList.remove('ec-facets-form-collapsed')
				facetsForm.classList.add('ec-facets-form-expanded')
			} else {
				facetsForm.classList.remove('ec-facets-form-expanded')
				facetsForm.classList.add('ec-facets-form-collapsed')
			}
		}

		if (facetsWrapper) {
			if (filtersExpanded) {
				facetsWrapper.classList.add('ec-facets-wrapper-expanded')
				facetsWrapper.classList.remove('ec-facets-wrapper-collapsed')
			} else {
				facetsWrapper.classList.remove('ec-facets-wrapper-expanded')
				facetsWrapper.classList.add('ec-facets-wrapper-collapsed')
			}
		}

		if (facetsToggle) {
			if (filtersExpanded) {
				previousColumns = currentColumns
				if (currentColumns === 3) {
					setTimeout(() => {
						setColumns(2, false, true)
					}, 50)
				}
				facetsToggle.classList.add('ec-facets-expanded')
			} else {
				const columnsToRestore = previousColumns
				previousColumns = null
				facetsToggle.classList.remove('ec-facets-expanded')
				if (columnsToRestore !== null && columnsToRestore !== currentColumns) {
					setTimeout(() => {
						setColumns(columnsToRestore, true, false)
					}, 50)
				}
			}
		}

		if (facetsLayout) {
			if (filtersExpanded) {
				facetsLayout.classList.add('ec-facets-layout-expanded')
			} else {
				facetsLayout.classList.remove('ec-facets-layout-expanded')
			}
		}

		if (toggleButton) {
			toggleButton.setAttribute('aria-expanded', filtersExpanded)
		}

		updateColumnButtonsState()
	}

	function loadSavedState() {
		const savedColumns = localStorage.getItem('ec-collection-columns')
		const savedMobileColumns = localStorage.getItem('ec-collection-columns-mobile')
		
		const facetsForm = document.querySelector('#FacetFiltersForm')
		const isFiltersExpanded = facetsForm?.classList.contains('ec-facets-form-expanded')
		const productGrid = document.querySelector('#product-grid')
		const isMobileView = isMobile()

		if (isMobileView && productGrid) {
			productGrid.classList.remove('grid--2-col-desktop', 'grid--3-col-desktop')
		}

		if (isMobileView) {
			if (savedMobileColumns) {
				setMobileColumns(parseInt(savedMobileColumns))
			} else {
				setMobileColumns(1, true)
			}
		} else {
			if (!savedColumns || savedColumns === '2') {
				localStorage.setItem('ec-collection-columns', '3')
				if (isFiltersExpanded) {
					setColumns(2, false, true)
				} else {
					setColumns(3, false, false)
				}
			} else {
				const columns = parseInt(savedColumns)
				if (isFiltersExpanded && columns === 3) {
					setColumns(2, false, false)
				} else {
					setColumns(columns)
				}
			}
		}

		setTimeout(() => {
			if (isMobile()) {
				filtersExpanded = true
				const facetsToggle = document.querySelector('.ec-facets-toggle')
				if (facetsToggle) {
					facetsToggle.classList.add('ec-facets-expanded')
				}
				const facetsLayout = document.querySelector('.ec-facets-layout')
				if (facetsLayout) {
					facetsLayout.classList.add('ec-facets-layout-expanded')
				}
				const facetsForm = document.querySelector('#FacetFiltersForm')
				if (facetsForm) {
					facetsForm.classList.add('ec-facets-form-expanded')
					facetsForm.classList.remove('ec-facets-form-collapsed')
				}
				const facetsWrapper = document.querySelector('#FacetsWrapperDesktop')
				if (facetsWrapper) {
					facetsWrapper.classList.add('ec-facets-wrapper-expanded')
					facetsWrapper.classList.remove('ec-facets-wrapper-collapsed')
				}
				const toggleButton =
					document.querySelector('.ec-filters-toggle-btn') ||
					document.querySelector('.ec-filter-btn')
				if (toggleButton) {
					toggleButton.setAttribute('aria-expanded', 'true')
				}
			} else {
				const facetsFormCheck = document.querySelector('#FacetFiltersForm')
				const isFiltersExpandedCheck =
					facetsFormCheck?.classList.contains('ec-facets-form-expanded')

				if (!isFiltersExpandedCheck) {
					filtersExpanded = false
					const facetsToggle = document.querySelector('.ec-facets-toggle')
					if (facetsToggle) {
						facetsToggle.classList.remove('ec-facets-expanded')
					}
					const facetsLayout = document.querySelector('.ec-facets-layout')
					if (facetsLayout) {
						facetsLayout.classList.remove('ec-facets-layout-expanded')
					}
					if (facetsFormCheck) {
						facetsFormCheck.classList.remove('ec-facets-form-expanded')
						facetsFormCheck.classList.add('ec-facets-form-collapsed')
					}
					const facetsWrapper = document.querySelector('#FacetsWrapperDesktop')
					if (facetsWrapper) {
						facetsWrapper.classList.remove('ec-facets-wrapper-expanded')
						facetsWrapper.classList.add('ec-facets-wrapper-collapsed')
					}
					const toggleButton =
						document.querySelector('.ec-filters-toggle-btn') ||
						document.querySelector('.ec-filter-btn')
					if (toggleButton) {
						toggleButton.setAttribute('aria-expanded', 'false')
					}
				} else {
					filtersExpanded = true
					if (currentColumns === 3) {
						setColumns(2, false, false)
					}
				}
			}
			updateColumnButtonsState()
		}, 50)
	}

	function waitForElement(selector, callback, maxAttempts = 50) {
		let attempts = 0
		const checkElement = () => {
			const element = document.querySelector(selector)
			if (element || attempts >= maxAttempts) {
				callback(element)
			} else {
				attempts++
				setTimeout(checkElement, 100)
			}
		}
		checkElement()
	}

	function initWhenReady() {
		waitForElement('.ec-filter-btn, .ec-filters-toggle-btn', (toggleButton) => {
			if (toggleButton) {
				toggleButton.addEventListener('click', (e) => {
					e.preventDefault()
					e.stopPropagation()
					toggleFilters()
				})
			}
		})

		function initColumnButtons() {
			const columnButtons = document.querySelectorAll('.ec-column-btn')
			if (columnButtons.length > 0) {
				columnButtons.forEach((btn) => {
					btn.addEventListener('click', (e) => {
						e.preventDefault()
						e.stopPropagation()
						const columns = parseInt(e.currentTarget.dataset.columns)
						if (!e.currentTarget.disabled) {
							setColumns(columns)
						}
					})
				})
				updateColumnButtonsState()
			} else {
				setTimeout(initColumnButtons, 100)
			}
		}
		initColumnButtons()

		function initMobileColumnButtons() {
			const mobileColumnButtons = document.querySelectorAll('.ec-column-btn-mobile')
			if (mobileColumnButtons.length > 0) {
				mobileColumnButtons.forEach((btn) => {
					btn.addEventListener('click', (e) => {
						e.preventDefault()
						e.stopPropagation()
						const columns = parseInt(e.currentTarget.dataset.columnsMobile)
						setMobileColumns(columns)
					})
				})
			} else {
				setTimeout(initMobileColumnButtons, 100)
			}
		}
		initMobileColumnButtons()

		function ensureCorrectGridClasses() {
			const productGrid = document.querySelector('#product-grid')
			if (productGrid && isMobile()) {
				productGrid.classList.remove('grid--2-col-desktop', 'grid--3-col-desktop')
			} else if (productGrid && !isMobile()) {
				productGrid.classList.remove('grid--1-col-tablet-down', 'grid--2-col-tablet-down')
			}
		}
		ensureCorrectGridClasses()

		loadSavedState()

		let resizeTimeout
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout)
			resizeTimeout = setTimeout(() => {
				const productGrid = document.querySelector('#product-grid')
				if (isMobile() && productGrid) {
					productGrid.classList.remove('grid--2-col-desktop', 'grid--3-col-desktop')
				} else if (!isMobile() && productGrid) {
					productGrid.classList.remove('grid--1-col-tablet-down', 'grid--2-col-tablet-down')
				}

				if (isMobile() && !filtersExpanded) {
					filtersExpanded = true
					const facetsToggle = document.querySelector('.ec-facets-toggle')
					if (facetsToggle) {
						facetsToggle.classList.add('ec-facets-expanded')
					}
					const facetsLayout = document.querySelector('.ec-facets-layout')
					if (facetsLayout) {
						facetsLayout.classList.add('ec-facets-layout-expanded')
					}
					const facetsForm = document.querySelector('#FacetFiltersForm')
					if (facetsForm) {
						facetsForm.classList.add('ec-facets-form-expanded')
						facetsForm.classList.remove('ec-facets-form-collapsed')
					}
					const facetsWrapper = document.querySelector('#FacetsWrapperDesktop')
					if (facetsWrapper) {
						facetsWrapper.classList.add('ec-facets-wrapper-expanded')
						facetsWrapper.classList.remove('ec-facets-wrapper-collapsed')
					}
					const toggleButton =
						document.querySelector('.ec-filters-toggle-btn') ||
						document.querySelector('.ec-filter-btn')
					if (toggleButton) {
						toggleButton.setAttribute('aria-expanded', 'true')
					}
					updateColumnButtonsState()
				} else if (!isMobile() && filtersExpanded) {
					filtersExpanded = false
					const facetsToggle = document.querySelector('.ec-facets-toggle')
					if (facetsToggle) {
						facetsToggle.classList.remove('ec-facets-expanded')
					}
					const facetsLayout = document.querySelector('.ec-facets-layout')
					if (facetsLayout) {
						facetsLayout.classList.remove('ec-facets-layout-expanded')
					}
					const facetsForm = document.querySelector('#FacetFiltersForm')
					if (facetsForm) {
						facetsForm.classList.remove('ec-facets-form-expanded')
						facetsForm.classList.add('ec-facets-form-collapsed')
					}
					const facetsWrapper = document.querySelector('#FacetsWrapperDesktop')
					if (facetsWrapper) {
						facetsWrapper.classList.remove('ec-facets-wrapper-expanded')
						facetsWrapper.classList.add('ec-facets-wrapper-collapsed')
					}
					const toggleButton =
						document.querySelector('.ec-filters-toggle-btn') ||
						document.querySelector('.ec-filter-btn')
					if (toggleButton) {
						toggleButton.setAttribute('aria-expanded', 'false')
					}
					updateColumnButtonsState()
				}
			}, 100)
		})
	}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }
})();
